import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';
import {loadPolyfills} from './polyfills-modern';

(async () => {
    await loadPolyfills();

    bootstrapApplication(AppComponent, appConfig)
        .catch((err) => console.error(err));

    // Our promo carousel relies on duplicate track ids, so we suppress the NG0955 warnings
    if (!environment.production) {
        const originalWarn = console.warn;
        console.warn = (...args: any[]) => {
            if (typeof args[0] === 'string' && args[0].includes('NG0955')) {
                return;
            }
            originalWarn.apply(console, args);
        };
    }
})();

